<template>
  <div class="container-main-body">
    <div class="list-container">
      <div class="list-btns-container">
        <el-button-group>
          <el-button v-for="btn in $store.state.currentLBtnList" :key="btn.id" :type="btn.button_type" size="mini" :icon="btn.button_icon" @click="handlerButtonDispatch(btn.fn)">{{btn.button_name}}</el-button>
        </el-button-group>
      </div>
      <!--列表数据 开始-->
      <div class="el-table-container" style="bottom: 5px;">
        <el-table :data="ds" stripe border default-expand-all row-key="id" height="100%" size="mini" style="width: 100%; border:1px solid #d1d1d1;" header-row-class-name="list-header-row" row-class-name="list-row" @selection-change="selectHandler" :tree-props="{children: 'children'}">
          <el-table-column type="selection" width="40" align="center" :selectable="selectableHandler"></el-table-column>
          <el-table-column label="菜单名称" prop="name" header-align="center"></el-table-column>
          <el-table-column label="英文名称" prop="en_name" width="200" header-align="center"></el-table-column>
          <el-table-column label="路由名" prop="route_name" width="200" header-align="center"></el-table-column>
          <el-table-column label="路由地址" prop="route_path" width="200" header-align="center"></el-table-column>
          <el-table-column label="排序" prop="sort" width="60" align="center"></el-table-column>
          <el-table-column label="操作" width="60" align="center" fixed="right">
            <template v-slot:default="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" circle plain @click.stop.prevent="viewHandler(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--列表数据 结束-->
    </div>
    <!-- 表单对话框 -->
    <ezz-dialog-form ref="DForm" :parent="this" />
  </div>
</template>
<script>
import EzzDialogForm from '@/views/modules/authority/menu/Form'
export default {
  data: function () {
    return {
      ds: [],
      delIds: [],
      operator_id: sessionStorage.getItem('operator_id')
    }
  },
  created: function () {

  },
  mounted: function () {
    this.loadData()
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function (fn, args) {
      var _this = this
      if (typeof _this[fn] === 'function') {
        _this[fn].apply(_this, args)
      } else {
        console.log('warning: the method is not exist')
      }
    },
    // 加载数据
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getMenus, {}, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          window.location.hash = '/'
        } else {
          _this.ds = _json.menus
        }
      })
    },
    // 新增
    addHandler: function () {
      this.$refs.DForm.addHandler()
    },
    // 删除
    delHandler: function (_row) {
      let _this = this
      let _idArr = (_row && _row.id) ? [_row.id] : _this.delIds

      if (_idArr.length === 0) {
        _this.$message({
          type: 'warning',
          message: '至少选择一条数据'
        })
      } else {
        _this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let _params = {
            ids: _idArr.join(','),
            operator_id: _this.operator_id
          }
          // ajax提交至服务器，删除数据
          _this.post(_this.$apis.delMenus, _params, function (res) {
            let _json = res.data
            if (_json.status === 'ok') {
              _this.loadData()
              _this.$message({
                type: 'success',
                message: '删除成功!'
              })
            } else {
              _this.$message({
                type: 'error',
                message: '无数据更新!'
              })
            }
          })
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    // 浏览
    viewHandler: function (_row) {
      let formId = _row.id
      this.$refs.DForm.viewHandler(formId)
    },
    // 多选事件
    selectHandler: function (selection) {
      let _idArr = []
      for (let _i = 0; _i < selection.length; ++_i) {
        _idArr.push(selection[_i].id)
      }
      this.delIds = _idArr
    },
    // 刷新事件
    refreshHandler: function () {
      this.loadData()
    },
    // 通过该方法，控制列表 checkbox 列是否允许勾选
    selectableHandler: function (_row, _index) {
      let operatorId = sessionStorage.getItem('operator_id')
      let createrId = _row.creater_id
      let delable = this.$store.state.delable
      // 函数需要一个返回值,true为可选,false为不可选择
      return (operatorId === createrId || delable === '是')
    }
  },
  components: {
    EzzDialogForm
  }
}
</script>
